module.exports = __webpack_public_path__ + "img/101.da778ac6.png";